<template lang="pug">
LanguageSwitcherMenu(
  :items='localeItems'
  :current='currentLocale'
  :active-code='locale'
  :label='t("language.switcherLabel")'
)
</template>

<script setup lang="ts">
import LanguageSwitcherMenu, {
  type LanguageSwitcherItem,
} from '~/components/language/LanguageSwitcherMenu.vue'

const { locale, locales, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()

const localeFlags: Record<string, string> = {
  en: '🇬🇧',
  de: '🇩🇪',
}

const localeItems = computed<LanguageSwitcherItem[]>(() =>
  locales.value.map((item) => ({
    code: item.code,
    name: item.name ?? item.code.toUpperCase(),
    flag: localeFlags[item.code] ?? '🏳️',
    path: switchLocalePath(item.code),
  })),
)

const currentLocale = computed(
  () =>
    localeItems.value.find((item) => item.code === locale.value) ?? {
      code: locale.value,
      name: locale.value.toUpperCase(),
      flag: localeFlags[locale.value] ?? '🏳️',
      path: switchLocalePath(locale.value),
    },
)
</script>
